<div class="scanner-containers-modal">
  <header class="scanner-containers-modal__header">
    <h2 class="scanner-containers-modal__title">
      {{ 'monitoring.scanner.details.containers-modal.title' | translate }}
    </h2>
  </header>

  <lib-table
    class="scanner-containers-modal__table"
    [columns]="CONTAINER_COLUMNS"
    [dataSource]="containers"
    [cellTemplates]="{
      name: nameTpl,
      ipRange: ipRangeTpl,
    }"
    [loaded]="true"
    [loading]="false"
    emptyState="monitoring.scanner.details.containers-modal.empty"
  />

  <ng-template
    #nameTpl
    let-row="data"
  >
    @let container = asContainer(row);
    <span class="scanner-containers-modal__cell-value">
      {{ container.name || '-' }}
    </span>
  </ng-template>

  <ng-template
    #ipRangeTpl
    let-row="data"
  >
    @let container = asContainer(row);
    <span class="scanner-containers-modal__cell-value">
      {{ container.ipRange || '-' }}
    </span>
  </ng-template>
</div>
